import { Link } from "react-router-dom";
import { Gradient } from "./Gradient";
import { Button } from "./tailwind/button";

export const NewShopifyInstallPage = ({ setShowSignUp }) => {
  return (
    <>
      <Gradient className="h-full">
        <div className="grid lg:grid-cols-2 grid-cols-1 h-full lg:mt-0 mt-20">
          {/* First column centered vertically and horizontally */}
          <div className="flex justify-center items-center mx-5">
            <div className="">
              {/* Text Section */}
              <div className="text-[3vw] font-title text-purple font-bold leading-none">
                Activate <span className="text-whatsapp">WhatsApp</span> ‍for a
                more human customer relation.
              </div>
              <div className="text-lg font-title text-purple mt-2">
                • Unlock 95% open rates and 40% CTR with Whatsapp campaigns
                <br />• Our team personally guides you from setup to campaigns
                optimization
              </div>

              {/* Buttons Section */}
              <div className="grid grid-cols-2 gap-4 mt-10">
                <Button
                  style={{ fontSize: "1.3rem" }}
                  onClick={() =>
                    window.open(
                      "https://calendly.com/tiphaine-simio/30mn?utm_source=new_shopify_install",
                    )
                  }
                  color="primaryButton"
                  className="text-[2rem] font-bold h-12"
                >
                  Book a demo to start 🚀
                </Button>
                {/* We should add it back if Shopify complains about the flow */}
                <div className="flex items-center">
                  <Link onClick={() => setShowSignUp(true)}>or sign up</Link>
                </div>
              </div>

              <div>
                <div className="text-xl font-subtitle text-purple mt-10 mb-4">
                  Integrated with <span className="text-pink">{">"}</span>
                  <span className="text-yellow">{">"}</span>
                </div>
                <img
                  alt="Simio customers"
                  src="https://storage.gadget.dev/files/22129/42940/media/file/2MPPY1SqgtQt0yzus4wjN/Logo integrations.png"
                  style={{
                    width: "80%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </div>

              <div>
                <div className="text-xl font-subtitle text-purple mt-10 mb-2">
                  Trusted by <span className="text-pink">+100 </span>
                  merchants
                </div>
                <img
                  alt="Simio customers"
                  src="https://storage.gadget.dev/files/22129/42940/media/file/6dn1u8GCoouORfvQMn67t/Logo marques.png"
                  style={{
                    width: "80%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Second column centered vertically and horizontally */}
          <div className="mx-5 flex justify-center items-center my-10">
            <div className="w-full">
              <div
                style={{
                  position: "relative",
                  paddingBottom: "calc(57% + 50px)",
                  height: "0px",
                }}
              >
                <iframe
                  id="gky5o10t4r"
                  src="https://app.guideflow.com/embed/lpnwj26iep"
                  width="100%"
                  height="100%"
                  style={{
                    overflow: "hidden",
                    position: "absolute",
                    border: "none",
                  }}
                  scrolling="no"
                  allow="clipboard-read; clipboard-write"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  allowFullScreen
                  allowtransparency="true"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className="relative z-50"></div>
      </Gradient>
    </>
  );
};
